export function getCloudinaryImageUrl(
	cloudName: string,
	publicId: string,
	options?: {
		width?: number;
		height?: number;
		crop?: 'fill' | 'thumb' | 'scale';
	}
): string {
	const params: string[] = ['f_auto', 'q_auto', 'dpr_auto'];
	if (options?.width) params.push(`w_${options.width.toString()}`);
	if (options?.height) params.push(`h_${options.height.toString()}`);
	if (options?.crop) params.push(`c_${options.crop}`);
	return `https://res.cloudinary.com/${cloudName}/image/upload/${params.join(',')}/${publicId}.webp`;
}
